/**
 * IMPORTS
 */

import { extendTheme } from '@chakra-ui/react';

/**
 * CORE
 */

// @see https://smart-swatch.netlify.app/ (get JS object)
const colors = {
  brand: {
    50: '#049bd7',
    100: '#0489be',
    200: '#0378a6',
    300: '#02658d',
    400: '#025373',
    500: '#02425c',
    600: '#012f41',
    700: '#011d28',
    800: '#000b0f',
    900: '#000000',
  },
  snapchat: {
    50: "#403F00",
    100: "#666500",
    200: "#8C8B00",
    300: "#B3B000",
    400: "#D9D600",
    500: "#FFFC0D",
    600: "#FFFD33",
    700: "#FFFD59",
    800: "#FFFE80",
    900: "#FFFEA6"
  },
  tiktok: {
    50: "#000000",
    100: "#000000",
    200: "#000000",
    300: "#000000",
    400: "#000000",
    500: "#000000",
    600: "#262626",
    700: "#404040",
    800: "#595959",
    900: "#737373"
  },
};

const fonts = {
  body: '"Open Sans",Arial,sans-serif',
  heading: 'Oswald,Helvetica,Arial,sans-serif',
};

const Button = {
  baseStyle: {
    borderRadius: 'full',
  },
};

const Heading = {
  baseStyle: {
    color: 'brand.500',
    textTransform: 'uppercase',
  },
};

const theme = extendTheme({
  colors,
  fonts,
  components: {
    Button,
    Heading,
  },
});

export default theme;
